export default __webpack_public_path__ + "static/media/previousIcon.3dab2cfa.svg";